// src/components/ui/ErrorState.js
import React from 'react';
import { AlertTriangle, WifiOff, Clock, ShieldOff } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import Btn from './Btn';

const ERROR_TYPES = {
  network: {
    icon: WifiOff,
    titleKey: 'errorState.network.title',
    descKey: 'errorState.network.desc',
  },
  timeout: {
    icon: Clock,
    titleKey: 'errorState.timeout.title',
    descKey: 'errorState.timeout.desc',
  },
  permission: {
    icon: ShieldOff,
    titleKey: 'errorState.permission.title',
    descKey: 'errorState.permission.desc',
  },
  generic: {
    icon: AlertTriangle,
    titleKey: 'errorState.generic.title',
    descKey: 'errorState.generic.desc',
  },
};

const ErrorState = ({ onRetry, msg, type }) => {
  const { t } = useTranslation();
  const config = ERROR_TYPES[type] || ERROR_TYPES.generic;
  const Icon = config.icon;
  const title = msg || t(config.titleKey);
  const desc = t(config.descKey);

  return (
    <div className="text-center py-16" data-testid="error-state">
      <div className="w-16 h-16 rounded-full bg-red-100 dark:bg-red-900/30 flex items-center justify-center mx-auto mb-4">
        <Icon size={28} className="text-red-500" />
      </div>
      <h3 className="text-lg font-bold mb-2 dark:text-gray-100">{title}</h3>
      <p className="text-gray-500 dark:text-gray-400 mb-4">{desc}</p>
      {onRetry && (
        <Btn v="outline" onClick={onRetry}>
          {t('errorState.retry')}
        </Btn>
      )}
    </div>
  );
};

export default ErrorState;
